import { validationIsEqual } from '../status';
import {
    validateEmail,
    validateName,
    validateAlphaNumericStringAllowingOnlyNumbers,
    validateNumericString,
    validateContactNumber,
    validatePassportNumber,
} from '@om/validation';
import { getIdNumberValue } from '@om/redux/selectors/personalPensionPlan/personalDetails';
import {
    RELATIONSHIP_SET_VALUE,
    FIRST_NAME_SET_VALUE,
    LAST_NAME_SET_VALUE,
    ID_NUMBER_SET_VALUE,
    EMAIL_SET_VALUE,
    POSTAL_ADDRESS_SET_VALUE,
    setRelationshipValid,
    setIdNumberValid,
    setPostalAddressValid,
    setFirstNameValid,
    setLastNameValid,
    setEmailValid,
    PHONE_NUMBER_SET_VALUE,
    setPhoneNumberValid,
} from '../../../actions/personalPensionPlan/nextOfKin';
import { validateKePassport } from '@om/validation/src/validators/ke-passport-validator';

let prevValidationAction = null;
export const nextOfKinValidation = (store, next, action) => {
    const gatsbyStack = process.env.GATSBY_COUNTRY_SELECTOR;

    const idNumber = getIdNumberValue(store.getState());

    const validationAction = (() => {
        let error;
        switch (action.type) {
            case FIRST_NAME_SET_VALUE:
                error = validateName(action.value, {
                    min: 2,
                    max: 48,
                    subject: 'First Name',
                });
                return setFirstNameValid(error);

            case LAST_NAME_SET_VALUE:
                error = validateName(action.value, {
                    min: 2,
                    max: 64,
                    subject: 'Last Name',
                });
                return setLastNameValid(error);

            case ID_NUMBER_SET_VALUE:
                error = validatePassportNumber(action.value, { min: 8, max: 15, required: true });

                if (error !== null && idNumber.value === action.value) {
                    error = 'You cannot use your own ID number';
                }

                return setIdNumberValid(error);

            case RELATIONSHIP_SET_VALUE:
                error = validateName(action.value, {
                    subject: 'Relationship',
                    min: 2,
                });
                return setRelationshipValid(error);

            case EMAIL_SET_VALUE:
                error = validateEmail(action.value, {
                    min: 6,
                    max: 200,
                    subject: 'Email address',
                    required: true,
                });
                return setEmailValid(error);

            case POSTAL_ADDRESS_SET_VALUE:
                error = validateAlphaNumericStringAllowingOnlyNumbers(action.value);
                return setPostalAddressValid(error);

            case PHONE_NUMBER_SET_VALUE:
                error = validateContactNumber(action.value, {
                    subject: 'Phone Number',
                    countryCode: gatsbyStack,
                });
                return setPhoneNumberValid(error);

            default:
                return null;
        }
    })();

    if (!validationAction || validationIsEqual(validationAction, prevValidationAction)) {
        return next(action);
    }

    store.dispatch(validationAction);
    prevValidationAction = validationAction;
    return next(action);
};
